"use strict";
// 这个文件夹里的东西通通废弃!!!!!!!!!!!!!!
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NumberTradeUtils = void 0;
const trade_utils_lib_1 = require("trade_utils_lib");
const decimal_js_1 = __importDefault(require("decimal.js"));
function getPricePrecision(tradeApi, symbol) {
    let precision = symbol.precision;
    if (!precision) {
        const s = tradeApi.getSymbol(symbol.base, symbol.quote);
        if (s && s.precision) {
            precision = s.precision;
        }
        else {
            if (symbol.quote === "BTC" || symbol.quote === "ETH") {
                precision = 8;
            }
            else {
                precision = 4;
            }
        }
    }
    return precision;
}
function getAmountPrecision(tradeApi, symbol) {
    let precision = symbol.amount;
    if (!precision) {
        const s = tradeApi.getSymbol(symbol.base, symbol.quote);
        if (s && s.amount) {
            precision = s.amount;
        }
        else {
            precision = 4;
        }
    }
    return precision;
}
/**
 * @deprecated 通通废弃
*/
exports.NumberTradeUtils = {
    toPriceBySymbol(tradeApi, value, symbol, rounding = decimal_js_1.default.ROUND_DOWN) {
        const precision = getPricePrecision(tradeApi, symbol);
        return trade_utils_lib_1.NumberCommonUtils.formatterDecimal(value, precision, rounding).toFixed(precision);
    },
    toAmountBySymbol(tradeApi, value, symbol, rounding = decimal_js_1.default.ROUND_DOWN) {
        const precision = getAmountPrecision(tradeApi, symbol);
        return trade_utils_lib_1.NumberCommonUtils.formatterDecimal(value, precision, rounding).toFixed(precision);
    },
    toPriceNumBySymbol(tradeApi, value, symbol, rounding = decimal_js_1.default.ROUND_DOWN) {
        const precision = getPricePrecision(tradeApi, symbol);
        return trade_utils_lib_1.NumberCommonUtils.formatterDecimal(value, precision, rounding).toNumber();
    },
    toAmountNumBySymbol(tradeApi, value, symbol, rounding = decimal_js_1.default.ROUND_DOWN) {
        const precision = getAmountPrecision(tradeApi, symbol);
        return trade_utils_lib_1.NumberCommonUtils.formatterDecimal(value, precision, rounding).toNumber();
    },
};
